import { AxiosResponse } from "axios";

import client from "libs/HttpClient";

/**
 * Represents the data required for admin login.
 */
interface LoginData {
  usernameOrEmail: string;
  password: string;
}

/**
 * Service class for handling CloudView authentication.
 */
class CloudViewService {
  /**
   * Performs admin login using the provided login data.
   *
   * @param loginData - The data containing email and password for authentication.
   * @returns A Promise that resolves to the AxiosResponse containing authentication results.
   */
  static login(loginData: LoginData): Promise<AxiosResponse<any, any>> {
    return client.post("admin/cloud-view/login", loginData);
  }

  /**
   * get User Details based on the provided request.
   *
   * @param request - The request parameters for getting a User Details.
   * @returns A Promise that resolves to the Axios response for the update User Details request.
   */
  static getUserDetails(request: any) {
    return client.get("admin/cloud-view/get-user-detail", request);
  }
}

export { CloudViewService };
